export const GC_USER_ID = 'graphcool-user-id'
export const GC_AUTH_TOKEN = 'graphcool-auth-token'
export const SHARED_USER_ID = 'shared-user-id'

export const ENERGY_TRACKER_ID = 'energy-tracker-id'
export const READING_TRACKER_ID = 'reading-tracker-id'
export const SLEEP_TRACKER_ID = 'sleep-tracker-id'
export const BODYWEIGHT_TRACKER_ID = 'bodyweight-tracker-id'
export const PROJECT_TRACKER_ID = 'project-tracker-id'

// naming convention coming from http://chir.ag/projects/name-that-color/
export const WHITE = '#FFFFFF'
export const BLACK = '#000000'
export const HAVELOCK_BLUE = '#5CADDC'
export const SHAKESPEARE = '#489ED1'
export const ALABASTER = '#FBFBFB'
export const BOULDER = '#777777'
export const KOROMIKO = '#FFB862'
export const VIKING = '#55DDBB'
export const TRANSPARENT = 'transparent'



// WEBPACK FOOTER //
// ./src/constants.js